import React, { Component, Fragment } from 'react';
import Timer from '../Timer';
import Upload from 'Components/Upload';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { ReactComponent as DropdownIcon } from 'Icons/download-white.svg';
import classNames from 'classnames';
import { ReactComponent as AcceptIcon } from 'Icons/checked.svg'
import { ReactComponent as RejectIcon } from 'Icons/reject.svg';
import { getUser } from 'Utils/storage';
import { HIKAL, PROVIDER_VALUE, STAR_CEMENT } from 'Constants/commonConstants';

export const RFQDetailsFooter = ({ rfq, showPopup, confirm, cancel, uploadBiddingDetails, downloadBiddingDetails, systemTime, isTermAccepted, clickedFileUpload, downloadProviderBidTrailDetails, courierAcceptOrRejectLoiList, postBidAll, courierAcceptOrRejectCPList, bulkAcceptRejectCP, courierBidStatus, clearMessage, bulkPostBid, bulkSubmitList, isWithDrawBid, totalBidExtension, disposalBidList, biddingStage}) => {
    const isDisabled = (rfq.rfqStatus === 99) ? false : JSON.parse(localStorage.getItem('termsAndConditionsAccepted'));
	const isCourierDisabled = (rfq.rfqStatus === 99) ? false : JSON.parse(localStorage.getItem('courierTermsAndConditionsAccepted'));
	let user = getUser()
	var data = (courierBidStatus || []).filter(e => e.transporter_id === user.id);
		data=data[0]
    return <div className="z-100 box-shadow pl-40 pv-20 pf b-0 col-1 bg-white flex flex-between">
        <Timer
            showInfo={true}
            from={rfq && rfq.rfqDetails && rfq.rfqDetails.biddingStart ? rfq.rfqDetails.biddingStart : ''}
            to={rfq && rfq.rfqDetails && rfq.rfqDetails.biddingEnd ? rfq.rfqDetails.biddingEnd : ''}
            currentTime={systemTime}
            showCompleteError={user.companyType === PROVIDER_VALUE}
        />
        
        {rfq && rfq.rfqDetails && !rfq.rfqDetails.acceptPartialSolution && (rfq && rfq.rfqDetails && rfq.rfqDetails.biddingEnd > systemTime) &&  
        <div className={classNames("mb-5 tCenter", {
            "error-color blinking": !rfq.rfqDetails.allBidsCompleted,
            "success-color": rfq.rfqDetails.allBidsCompleted
        })}>
            {rfq && rfq.rfqDetails && <div className="fBold fs-16">
                <span>{rfq.rfqDetails.allBidsCompleted ? "All Bids Posted Successfully " : `* It is mandatory to bid for all ${rfq.type == 9 ? 'lanes' : 'trips'}`}</span>
                {rfq.type != 9 && <>(<span className="success-color ml-5">{rfq.rfqDetails.bidCompletedCount}</span> | <span className="error-color">{rfq.rfqDetails.bidPendingCount}</span> )</>}
            </div>}
        </div>}
        { rfq && (rfq.event_contract || STAR_CEMENT.includes(rfq.companyId)) &&
            <div className="fBold fs-16">
                <span className='theme-color'>Bid Extension:</span> <span className={'orange-color'}>{rfq.bid_extension_count}</span> / <span className='success-color'>{totalBidExtension}</span>
            </div>
        }
        {
            rfq && rfq.type === 9 && (rfq && rfq.rfqDetails && rfq.rfqDetails.biddingEnd > systemTime) &&
            <button
            	className={classNames("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-25", {
                    'notselectable': disposalBidList.length === 0
                })}
            	onClick={() => postBidAll(1,disposalBidList )}
            	>
            	    {'Update Rate'}
                </button>
        }
        {rfq && <div className="flex">
            {
                rfq.rfqDetails.serviceType === 3 && courierAcceptOrRejectCPList.length > 0 &&
                <div className="mr-50 fBold flex flex-middle">
                    <div className="fs-20">{`CP (${courierAcceptOrRejectCPList.length}) :`}</div>
                    <AcceptIcon className="wt-25 ht-25 ml-5 curP z-100" onClick={() => bulkAcceptRejectCP(courierAcceptOrRejectCPList, true)} />
                    <RejectIcon className="wt-25 ht-25 ml-5 curP z-100" onClick={() => bulkAcceptRejectCP(courierAcceptOrRejectCPList, false)} />
                </div>
            }
            {
                rfq.rfqDetails.serviceType === 3 && courierAcceptOrRejectLoiList.length > 0 && 
                <div className="mr-50 fBold flex flex-middle">
                    <div className="fs-20">{`LOI (${courierAcceptOrRejectLoiList.length}) :`}</div>
                    <AcceptIcon className="wt-25 ht-25 ml-5 curP z-100" onClick={() => postBidAll(2, courierAcceptOrRejectLoiList)} />
                    <RejectIcon className="wt-25 ht-25 ml-5 curP z-100" onClick={() => postBidAll(3, courierAcceptOrRejectLoiList)} />
                </div>
            }

            {
				 (rfq.rfqDetails.serviceType === 3 || rfq.type === 4) && data && !data.courier_message ? <div className="fBold flex flex-middle">
					 <span className="fSemibold fs-14 green-color mr-10"> {data.courier_bid_message} {data.countOfFailed} {data.countOfSuccess}   {data.totalCount}</span>
					 {data && data.countOfFailed && <button className="ht-25 curP mr-25 z-100 theme-color fs-16 fBold" onClick={() =>clearMessage()} >OK</button>}
				 </div> : <span className="fSemibold fs-18 green-color mr-30">{data && data.courier_message}</span>
            }
            {(rfq && HIKAL.includes(rfq.companyId) && rfq.rfqDetails && rfq.rfqDetails.biddingEnd > systemTime) && <button
            	className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-25"
            	onClick={bulkPostBid}
            	>
            	    {`Submit All (${bulkSubmitList.length})`}
                </button>
            }
            {
				 (rfq && !biddingStage['yetToStart'] && rfq.rfqDetails && rfq.rfqDetails.biddingEnd > systemTime) && 
                <div onClick={clickedFileUpload}>
					 <Upload onChange={uploadBiddingDetails} disabled={rfq.rfqDetails.serviceType === 3 ? (!isDisabled || !isCourierDisabled) : !isDisabled}>
                        <button
							 className={classNames("ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-20", rfq.rfqDetails.serviceType === 3 ? ({
                        		inputDisabled: !isDisabled,
							 			}, { inputDisabled: !isCourierDisabled }) : { inputDisabled: !isDisabled })}
							 	disabled={rfq.rfqDetails.serviceType === 3 ? (!isCourierDisabled) : (!isDisabled)}>
                        	Upload Bids
                        </button>
                    </Upload>
                </div>
            }
            {
                showPopup &&
                <ConfirmationPopup
                    text={'Are You Sure You Want To Upload An Excel?'}
                    onConfirm={confirm}
                    onCancel={cancel}
                />
            }
            {rfq.isRfqClosed && <div className="mr-30 mt-10">
            <span className="green-color fs-16 fBold">Auction has been completed and result will be intimated shortly over Mail</span>
                </div>
            }
            <button
				 className={classNames("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20", rfq.rfqDetails.serviceType === 3 ? ({
					 inputDisabled: !isDisabled,
				 		}, { inputDisabled: !isCourierDisabled }) : { inputDisabled: !isDisabled })}
            		onClick={downloadBiddingDetails}
				 		disabled={rfq.rfqDetails.serviceType === 3 ? (!isCourierDisabled) : (!isDisabled)}>
            	Download Template
            </button>
            {!biddingStage['yetToStart'] && rfq.type !== 9 && <button
            	className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-25"
            	onClick={downloadProviderBidTrailDetails}
            	>
            	Download Bid Trail
            </button>}
        </div>}
        
    </div>
}
